import React from "react";
import styled from "@emotion/styled";
import { QuoteModule } from "@domain/learn/learn-service";
import { physioMeTabletBreakpoint } from "@ui/style";
import { colors } from "@ui/style/colors";
import { fonts } from "@ui/style/font";
import { getInitials } from "@utils/string-utils";

interface QuoteModuleSectionProps {
	quoteModule: QuoteModule;
}

export const QuoteModuleSection = ({ quoteModule }: QuoteModuleSectionProps): JSX.Element => {
	const author = quoteModule.author;
	console.log("author image:", author?.image);
	console.log("author image url:", author?.image?.url);
	return (
		<QuoteModuleContainer>
			<QuoteContent>
				<QuoteDivider />
				<QuoteText>{quoteModule.quote}</QuoteText>
				{author && (
					<QuoteAuthorSection>
						{author.image?.url ? (
							<AuthorImage src={author.image.url} alt={author.name} loading="lazy" />
						) : (
							<AuthorInitials>{getInitials(author.name)}</AuthorInitials>
						)}
						<AuthorInfo>
							<AuthorName>{author.name}</AuthorName>
							{author.title && <AuthorTitle>{author.title}</AuthorTitle>}
						</AuthorInfo>
					</QuoteAuthorSection>
				)}
			</QuoteContent>
		</QuoteModuleContainer>
	);
};

// Quote Module Styles
const QuoteModuleContainer = styled.div`
	position: relative;
	width: 100%;
	margin-top: 16px;
	margin-bottom: 16px;
	background: #ecedfc;
	border-radius: 16px;
	padding: 32px 40px;
	display: flex;
	flex-direction: column;
	gap: 16px;

	@media ${physioMeTabletBreakpoint} {
		padding: 24px 32px;
	}

	@media (max-width: 520px) {
		padding: 20px 24px;
	}
`;

const QuoteContent = styled.div`
	display: flex;
	flex-direction: row;
	align-items: stretch;
	gap: 16px;
	width: 100%;
`;

const QuoteDivider = styled.div`
	width: 4px;
	background: ${colors.primary};
	border-radius: 16px;
	flex-shrink: 0;
`;

const QuoteText = styled.div`
	flex: 1;
	font-family: ${fonts.header};
	font-size: 18px;
	font-weight: 500;
	font-style: italic;
	color: #212bc2;
	line-height: 1;
	display: flex;
	flex-direction: column;

	p {
		font-family: ${fonts.header};
		font-size: 18px;
		font-weight: 500;
		font-style: italic;
		color: #212bc2;
		line-height: normal;
		margin: 0;

		&:not(:last-child) {
			margin-bottom: 16px;
		}
	}

	strong {
		font-weight: 700;
	}

	em {
		font-style: italic;
	}
`;

const QuoteAuthorSection = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 16px;
`;

const AuthorImage = styled.img`
	width: 55px;
	height: 55px;
	border-radius: 50%;
	object-fit: cover;
	flex-shrink: 0;
`;

const AuthorInitials = styled.div`
	width: 55px;
	height: 55px;
	border-radius: 50%;
	background: ${colors.grey80};
	color: ${colors.white};
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: ${fonts.header};
	font-size: 18px;
	font-weight: 700;
	flex-shrink: 0;
`;

const AuthorInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

const AuthorName = styled.div`
	font-family: ${fonts.header};
	font-size: 18px;
	font-weight: 700;
	color: #212bc2;
	line-height: 1;
`;

const AuthorTitle = styled.div`
	font-family: ${fonts.body};
	font-size: 18px;
	font-weight: 400;
	color: #212bc2;
	line-height: 1;
`;
